import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { useAppSelector } from '../../../redux/store';
import { isTestEnvironment } from '../../../utils/utils';
import { ActionArrow } from './actionArrow';
import { getSeatYDest } from './singleActionArrowContainer';
export const MultiActionArrowContainer = ({ seatIndex }) => {
    const seatWidth = useAppSelector((state) => state.gameDimensions.seatDimensions?.w);
    const seatHeight = useAppSelector((state) => state.gameDimensions.seatDimensions?.h);
    const seatX = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex].x);
    const seatY = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex].y);
    if (seatWidth === undefined || seatHeight === undefined) {
        return null;
    }
    return (_jsx(Container, { "pixi-data": isTestEnvironment() ? { type: 'multi-action-arrow', seatIndex } : null, x: seatX, y: getSeatYDest(seatY, seatHeight), children: _jsx(ActionArrow, {}) }, seatIndex));
};
